import type { ReactNode } from 'react';

export const symbol_sports_tennis: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M520-392q-89 0-139.5 13T297-333L144-180q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l152-152q33-33 47-82.5T315-597q0-57 25-112t76-106q88-88 193-100t173 56q68 68 56 174T738-491q-51 51-106 75t-112 24Zm-107-99q49 49 133 36.5T697-534q67-67 80-149.5T741-815q-49-49-132.5-36.5T458-772q-67 67-80.5 149.5T413-491ZM634-82q-42-42-42-102t42-102q42-42 102-42t102 42q42 42 42 102T838-82q-42 42-102 42T634-82Zm162-42q24-24 24-60t-24-60q-24-24-60-24t-60 24q-24 24-24 60t24 60q24 24 60 24t60-24Zm-60-60Z"
		/>
	</svg>
);
